import { api } from "../Apis/interceptor";

export const get = function (id, cust_id, branch, userId) {
  return api.get(
    "/api/v1/opportunity/" +
      id +
      "/" +
      cust_id +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key +
      "/" +
      userId
  );
};
export const getOppData = function (id) {
  return api.get("/api/v1/opportunity/" + id);
};
export const all = function (
  cust_id,
  page,
  sortBy,
  orderBy,
  filterData,
  isRestricted,
  loggedInUser,
  defAndSec,
  branch
) {
  return api.get(
    "/api/v1/opportunityAll/" +
      cust_id +
      "/" +
      page +
      "/" +
      sortBy +
      "/" +
      orderBy +
      "/" +
      filterData.branch_id +
      "/" +
      filterData.business_unit +
      "/" +
      filterData.bid_Leader +
      "/" +
      filterData.bidStatus +
      "/" +
      filterData.winwork_display +
      "/" +
      filterData.sector +
      "/" +
      filterData.filter +
      "/" +
      isRestricted +
      "/" +
      loggedInUser +
      "/" +
      defAndSec +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key
  );
};
export const activeBids = function (cust_id) {
  return api.get("/api/v1/activeBids/" + cust_id);
};

export const oppByClient = function (client_id, cust_id) {
  return api.get("/api/v1/opportunityByClient/" + client_id + "/" + cust_id);
};

export const filter = function (
  skip,
  limit,
  cust_id,
  pattern,
  search,
  sortBy,
  orderBy,
  filterData,
  isRestricted,
  loggedInUser,
  defAndSec,
  branch
) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/opportunity_filter", {
    params: {
      skip: skip,
      limit: limit,
      cust_id: cust_id,
      pattern: pattern,
      search: search,
      sortBy: sortBy,
      orderBy: orderBy,
      filterBranch: JSON.stringify(filterData.branch_id),
      business_unit: JSON.stringify(filterData.business_unit),
      bidLeader: JSON.stringify(filterData.bid_Leader),
      bidStatus: JSON.stringify(filterData.bidStatus),
      winwork_display: JSON.stringify(filterData.winwork_display),
      services: JSON.stringify(filterData.services),
      sector: JSON.stringify(filterData.sector),
      region: JSON.stringify(filterData.region),
      procurement_route: JSON.stringify(filterData.procurement_route),
      filter: filterData.filter,
      timeperiod: filterData.timeperiod,
      timeperiod_range: filterData.timeperiod_range,
      isRestricted: isRestricted,
      loggedInUser: loggedInUser,
      defAndSec: defAndSec,
      branchId: branch.branch_id,
      branchKey: branch.branch_key,
    },
  });
};

//approve

export const approveOpp = function (opportunityData) {
  return api.put("/api/v1/approveOpportunity/", {
    opportunityData: opportunityData,
  });
};
// export const getPageLike=function(pattern, cust_id, sortBy, orderBy, filterData,isRestricted,loggedInUser,defAndSec,branch){
// 	return api.get('/api/v1/opportunityLike/'+pattern+"/"+cust_id+"/"+ sortBy+"/"+ orderBy+"/"+filterData.bid_Leader+"/"+filterData.bidStatus+"/"+filterData.winwork_display+"/"+filterData.sector+"/"+filterData.filter+"/"+isRestricted+"/"+loggedInUser+"/"+defAndSec+"/"+branch.branch_id+"/"+branch.branch_key);
// };

export const create = function (opportunityData) {
  return api.post("/api/v1/opportunity/", opportunityData);
};
export const saveStage = function (id, opportunityData) {
  return api.post("/api/v1/opportunityStage/" + id, opportunityData);
};
export const loadFor = function (customer_id, opportunity_id) {
  return api.get(
    "/api/v1/opportunityStage/" + customer_id + "/" + opportunity_id
  );
};

export const update = function (id, opportunityData) {
  return api.put("/api/v1/opportunity/" + id, opportunityData);
};

export const updateWinplan = function (id, testSections) {
  return api.put("/api/v1/opportunity/" + id, testSections);
};

//not used
export const delete1 = function (id) {
  return api.delete("/api/v1/opportunity/" + id);
};

export const getSeq = function (cust_id) {
  return api.get("/api/v1/opportunityId/" + cust_id);
};

export const multiDelete = function (ids) {
  return api.delete("/api/v1/opportunityMultiDelete", {
    params: {
      id: ids,
    },
  });
};

// export const bySeqId=function(searchVal, cust_id, sortBy, orderBy, filterData,isRestricted,loggedInUser,defAndSec,branch){
// 	return api.get('/api/v1/opportunity/bySeqId/' + searchVal+"/"+ cust_id+"/"+ sortBy+"/"+ orderBy+"/"+filterData.bid_Leader+"/"+filterData.bidStatus+"/"+filterData.winwork_display+"/"+filterData.sector+"/"+filterData.filter+"/"+isRestricted+"/"+loggedInUser+"/"+defAndSec+"/"+branch.branch_id+"/"+branch.branch_key);
// };

export const byName = function (searchVal, cust_id, sortBy, orderBy) {
  return api.get(
    "/api/v1/opportunityByName/" +
      searchVal +
      "/" +
      cust_id +
      "/" +
      sortBy +
      "/" +
      orderBy
  );
};

export const updateAdvisor = function (id, cust_id, advisorForm) {
  return api.put("/api/v1/updateAdvisor/" + id + "/" + cust_id, advisorForm);
};

export const addNewAdvisor = function (id, cust_id, advisorForm) {
  return api.put("/api/v1/addNewAdvisor/" + id + "/" + cust_id, advisorForm);
};

export const addExistingAdvisor = function (id, cust_id, advisor_id, clidata) {
  return api.put("/api/v1/addExistingAdvisor/" + id + "/" + cust_id, {
    advisor_id: advisor_id,
    clidata: clidata,
  });
};

export const editAdvisor = function (id, cust_id, index, selectedAdv) {
  return api.put(
    "/api/v1/editAdvisor/" + id + "/" + cust_id + "/" + index,
    selectedAdv
  );
};

export const updateExistingAdvisor = function (id, cust_id, selectedAdv) {
  return api.put(
    "/api/v1/updateExistingAdvisor/" + id + "/" + cust_id,
    selectedAdv
  );
};

// export const addNewMember = function(id, cust_id, index, addNewForm) {
//     return api.put('/api/v1/addNewMember/' + id + "/" + cust_id + "/" + index, addNewForm);
// };

export const updateExistingMember = function (
  id,
  cust_id,
  index,
  organisation_id,
  selectedAdv
) {
  return api.put(
    "/api/v1/updateExistingMember/" +
      id +
      "/" +
      cust_id +
      "/" +
      index +
      "/" +
      organisation_id,
    selectedAdv
  );
};

// export const getExistingMemberList = function(id, cust_id, org_id) {
//     return api.get('/api/v1/getExistingMemberList/' + id + "/" + cust_id + "/" + org_id);
// };

export const addClientTeam = function (
  id,
  cust_id,
  client_id,
  client_name,
  clientForm
) {
  return api.put(
    "/api/v1/addClientTeam/" +
      id +
      "/" +
      cust_id +
      "/" +
      client_id +
      "/" +
      client_name,
    clientForm
  );
};

export const editClTeam = function (
  id,
  cust_id,
  client_id,
  clTeam,
  stakeholder
) {
  return api.put("/api/v1/editClTeam/" + id + "/" + cust_id + "/" + client_id, {
    clTeam: clTeam,
    stakeholder: stakeholder,
  });
};

export const updateExistClTeam = function (
  id,
  cust_id,
  clt_name,
  selectedTeam
) {
  return api.put(
    "/api/v1/updateExistClTeam/" + id + "/" + cust_id + "/" + clt_name,
    selectedTeam
  );
};

export const addBidTeam = function (id, cust_id, user_id) {
  return api.put("/api/v1/addBidTeam/" + id + "/" + cust_id + "/" + user_id);
};

export const getWinPlans = function (id, cust_id, winplan_name) {
  return api.get("/api/v1/winPlans/" + id + "/" + cust_id + "/" + winplan_name);
};

export const getOpportunity = function (id, cust_id) {
  return api.get("/api/v1/frameworkOpportunity/" + id + "/" + cust_id);
};

export const getClientOpportunity = function (id, cust_id) {
  return api.get("/api/v1/clientOpportunity/" + id + "/" + cust_id);
};

export const generateWPlan = function (
  opportunity_id,
  cust_id,
  opportunity_needs,
  opportunity_objectives,
  opportunity_values,
  project_needs,
  project_objectives,
  project_values,
  stakeholder_needs,
  stakeholder_objectives,
  testSections,
  client_rds_score,
  totalRiskScoreByCat
) {
  return api.put("/api/v1/generateWPlan/" + cust_id, {
    opportunity_id: opportunity_id,
    opportunity_needs: opportunity_needs,
    opportunity_objectives: opportunity_objectives,
    project_needs: project_needs,
    opportunity_values: opportunity_values,
    project_objectives: project_objectives,
    stakeholder_needs: stakeholder_needs,
    stakeholder_objectives: stakeholder_objectives,
    project_values: project_values,
    winPlans: testSections,
    client_rds_score: client_rds_score,
    totalRiskScoreByCat: totalRiskScoreByCat,
  });
};

export const generateAdvisor = function (id, cust_id, advisor) {
  //window.open('/api/v1/generateAdvisor?token=' + token + "&opportunity_id=" + id + "&cust_id=" + cust_id);
  return api.put("/api/v1/generateAdvisor/" + cust_id, {
    opportunity_id: id,
    advisor: advisor,
  });
};

export const winRateBySector = function (cust_id, win_rate) {
  return api.get("/api/v1/winRateBySector/", {
    params: { cust_id: cust_id, win_rate: win_rate },
  });
};

export const getNext = function (id, cust_id) {
  return api.get("/api/v1/opportunityNext/" + id + "/" + cust_id);
};

export const getPrevious = function (id, cust_id) {
  return api.get("/api/v1/opportunityPrev/" + id + "/" + cust_id);
};

export const updateWinPlanSection = function (id, cust_id, winThemeData) {
  return api.put(
    "/api/v1/updateWinPlanSection/" + id + "/" + cust_id,
    winThemeData
  );
};
export const activeBidByRate = function (cust_id, winRate) {
  return api.get("/api/v1/activeBidByRate/" + cust_id + "/" + winRate);
};
export const opportunityByYear = function (cust_id, year) {
  return api.get("/api/v1/opportunityByYear/" + cust_id + "/" + year);
};

export const crmTest = function () {
  return api.get("/api/v1/crm/");
};

export const getScoringFactor = function (cust_id, opp_id) {
  return api.get("/api/v1/getScoringFactor/" + cust_id + "/" + opp_id);
};

export const getTopFrameworks = function (
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  service,
  winworkStage
) {
  return api.get("/api/v1/getTopFrameworks", {
    params: {
      cust_id: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      service: service,
      winworkStage: winworkStage,
    },
  });
};

export const movingStages = function (opportunityData) {
  return api.put("/api/v1/movingStages/", opportunityData);
};

export const getTimesheet = function (cust_id, userId, oppId) {
  return api.get("/api/v1/getTimesheet/" + cust_id, {
    params: { userId: userId, oppId: oppId },
  });
};

export const generateTimesheet = function (timesheetData, username) {

  window.open(`${process.env.REACT_APP_BACKEND_URL}/api/v1/generateTimesheet?timesheetData=${timesheetData}&username=${username}`);
 
  // window.open(
  //   `${process.env.REACT_APP_BACKEND_URL}`+"/api/v1/generateTimesheet?token=" +
  //     token +
  //     "&timesheetData=" +
  //     timesheetData +
  //     "&username=" +
  //     username
  // );
};

export const updateTimesheet = function (cust_id, fileName) {
  return api.put("/api/v1/updateTimesheet/" + cust_id, { fileName: fileName });
};

export const getUsersTimesheet = function (cust_id, branch) {
  return api.get(
    "/api/v1/getUsersTimesheet/" +
      cust_id +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key
  );
};

export const generateUsersTimesheet = function (
  cust_id,
  branch,
  username
) {
  window.open(`${process.env.REACT_APP_BACKEND_URL}/api/v1/generateUsersTimesheet?cust_id=${cust_id}&branch_id=${branch.branch_id}&branch_key=${branch.branch_key}&username=${username}`);
};

export const updateUsersTimesheet = function (cust_id, fileName) {
  return api.put("/api/v1/updateUsersTimesheet/" + cust_id, {
    fileName: fileName,
  });
};

export const calcWinscore = function (
  cust_id,
  oppIds,
  bdStage,
  pqqStage,
  ittStage,
  WinWorkStage
) {
  return api.put("/api/v1/calcWinscore/" + cust_id, {
    oppIds: oppIds,
    bdStage: bdStage,
    pqqStage: pqqStage,
    ittStage: ittStage,
    WinWorkStage: WinWorkStage,
  });
};
export const getProjectNumber = function (cust_id, opp_id) {
  return api.get("/api/v1/getProjectNumber/" + cust_id + "/" + opp_id);
};

export const getOppAccess = function (opp_id, user_id) {
  return api.get("/api/v1/getOppAccess/" + opp_id + "/" + user_id);
};

export const removeOpp = function (opp_id, user_id, tab) {
  return api.post("/api/removeOppCache", {
    opp_id: opp_id,
    user_id: user_id,
    tab: tab,
  });
};

export const cloneOpportunity = function (id, opportunityData) {
  return api.post("/api/v1/cloneOpportunity/" + id, opportunityData);
};

export const updateNewWinplan = function (id, section, winplan, advisor) {
  return api.put("/api/v1/updateWinPlan/" + id + "/" + section, {
    winplan: winplan,
    advisor: advisor,
  });
};
export const getDate = function () {
  return api.get("/api/v1/getDate");
};

export const getBaxallID = function () {
  return api.get("/api/v1/rest/getenv");
};

export const uploadToBox = function (cust_id, oppData) {
  return api.post("/api/v1/uploadToBox/" + cust_id, oppData);
};

export const generateClientReport = function (id, cust_id, clientInfo) {
  return api.put("/api/v1/generateClientReport/" + cust_id, {
    opportunity_id: id,
    clientInfo: clientInfo,
  });
};

export const generateRiskReport = function (
  id,
  cust_id,
  totalRiskScoreByCat,
  RiskScoreByCat,
  OppScoreByCat,
  riskDetails,
  opportunity_identification,
  riskCount,
  oppCount
) {
  //window.open('/api/v1/generateRiskReport?token=' + token + "&opportunity_id=" +id + "&cust_id=" + cust_id + "&totalRiskScoreByCat=" + JSON.stringify(totalRiskScoreByCat) + "&RiskScoreByCat=" +  JSON.stringify(RiskScoreByCat) + "&OppScoreByCat=" + JSON.stringify(OppScoreByCat));
  return api.put("/api/v1/generateRiskReport/" + cust_id, {
    opportunity_id: id,
    totalRiskScoreByCat: totalRiskScoreByCat,
    RiskScoreByCat: RiskScoreByCat,
    OppScoreByCat: OppScoreByCat,
    riskDetails: riskDetails,
    opportunityDetails: opportunity_identification,
    riskCount: riskCount,
    oppCount: oppCount,
  });
};

export const generateGoalReport = function (
  id,
  cust_id,
  goalDetails,
  userFilterReport
) {
  //window.open('/api/v1/generateRiskReport?token=' + token + "&opportunity_id=" +id + "&cust_id=" + cust_id + "&totalRiskScoreByCat=" + JSON.stringify(totalRiskScoreByCat) + "&RiskScoreByCat=" +  JSON.stringify(RiskScoreByCat) + "&OppScoreByCat=" + JSON.stringify(OppScoreByCat));
  return api.put("/api/v1/generateGoalReport/" + cust_id, {
    opportunity_id: id,
    goalDetails: goalDetails,
    userFilterReport: userFilterReport,
  });
};

export const generateMetricsReport = function (
  id,
  cust_id,
  criticalAreas,
  buildPerform,
  projectKPI,
  currency
) {
  return api.put("/api/v1/generateMetricsReport/" + cust_id, {
    opportunity_id: id,
    criticalAreas: criticalAreas,
    buildPerform: buildPerform,
    projectKPI: projectKPI,
    currency,
  });
};

export const generateTenderSalesReport = function (
  id,
  cust_id,
  UserID,
  curTime
) {
  return api.put(
    "/api/v1/generateTenderSalesReport/" + cust_id + "/" + UserID,
    { opportunity_id: id, time: curTime }
  );
};
export const generateTenderDocumentReviewReport = function (
  id,
  cust_id,
  UserID,
  project_address
) {
  return api.put(
    "/api/v1/generateTenderDocumentReviewReport/" + cust_id + "/" + UserID,
    { opportunity_id: id, projectAddress: project_address }
  );
};
export const downloadDocs = function (fileName) {
  window.open(`${process.env.REACT_APP_BACKEND_URL}/api/v1/downloadDocs?fileName=${fileName}`);
};

export const riskActionComplete = function (
  opportunity_id,
  cust_id,
  parentIndex,
  index,
  data,
  actionFrom
) {
  return api.put("/api/v1/riskActionComplete/" + cust_id, {
    opportunity_id: opportunity_id,
    parentIndex: parentIndex,
    index: index,
    data: data,
    actionFrom: actionFrom,
  });
};
//qualitative action complete
export const qualitativeGoalActionComplete = function (
  opportunity_id,
  cust_id,
  parentIndex,
  index,
  data
) {
  return api.put("/api/v1/qualitativeGoalActionComplete/" + cust_id, {
    opportunity_id: opportunity_id,
    parentIndex: parentIndex,
    index: index,
    data: data,
  });
};

//target action complete
export const goalActionComplete = function (
  opportunity_id,
  cust_id,
  parentIndex,
  index,
  data
) {
  return api.put("/api/v1/goalActionComplete/" + cust_id, {
    opportunity_id: opportunity_id,
    parentIndex: parentIndex,
    index: index,
    data: data,
  });
};

export const reviewActionComplete = function (
  opportunity_id,
  cust_id,
  index,
  data,
  rHeadName,
  actionFrom
) {
  return api.put("/api/v1/reviewActionComplete/" + cust_id, {
    opportunity_id: opportunity_id,
    index: index,
    data: data,
    rHeadName: rHeadName,
    actionFrom: actionFrom,
  });
};

export const midReviewActionComplete = function (
  opportunity_id,
  cust_id,
  index,
  data,
  rHeadName,
  actionFrom
) {
  return api.put("/api/v1/midReviewActionComplete/" + cust_id, {
    opportunity_id: opportunity_id,
    index: index,
    data: data,
    rHeadName: rHeadName,
    actionFrom: actionFrom,
  });
};

export const submissionActionComplete = function (
  opportunity_id,
  cust_id,
  PParentIndex,
  parentIndex,
  index,
  data
) {
  return api.put("/api/v1/submissionActionComplete/" + cust_id, {
    opportunity_id: opportunity_id,
    PParentIndex: PParentIndex,
    parentIndex: parentIndex,
    index: index,
    data: data,
  });
};

export const wplanActionComplete = function (
  opportunity_id,
  cust_id,
  parentIndex,
  index,
  section,
  data
) {
  return api.put("/api/v1/wplanActionComplete/" + cust_id, {
    opportunity_id: opportunity_id,
    parentIndex: parentIndex,
    index: index,
    section: section,
    data: data,
  });
};

export const saveDoc = function (cust_id, opportunity_id, data) {
  return api.put("/api/v1/saveDoc/" + cust_id, {
    opportunity_id: opportunity_id,
    data: data,
  });
};

export const overviewClientOpps = function (client_id, cust_id, flag) {
  return api.get(
    "/api/v1/overviewClientOpps/" + client_id + "/" + cust_id + "/" + flag
  );
};

export const getAssociatedProj = function (cust_id, client_id, contact_id) {
  return api.get(
    "/api/v1/getAssociatedProj/" + cust_id + "/" + client_id + "/" + contact_id
  );
};
//get organization linked contact
export const getAssociatedProjOrg = function (cust_id, contact_id) {
  return api.get("/api/v1/getAssociatedProjOrg/" + cust_id + "/" + contact_id);
};

export const saveWinscoreBox = function (cust_id, winScoreLabels) {
  return api.put("/api/v1/saveWinscoreBoxLabels/" + cust_id, {
    winScoreLabels: winScoreLabels,
  });
};
//get bid leaders
export const getBidLeader = function (cust_id) {
  return api.get("/api/v1/getBidLeader/" + cust_id);
};

//download a file or image
export const downloadFile = function (file) {
  return api.post(
    "/api/v1/downloadFile",
    { file: file },
    {
      headers: {
        "Content-type": "application/json",
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      // responseType: 'arraybuffer'
    }
  );
};
//delete a uploaded file
export const deleteFile = function (file, opp_id, goalDetails) {
  return api.put("/api/v1/deleteFile", { file: file, opp_id, goalDetails });
};
export const deleteFileQualitative = function (file, opp_id, goalDetails) {
  return api.put("/api/v1/deleteFileQualitative", { file: file, opp_id, goalDetails });
};
